import _ from 'underscore';
import { addColumnOnLevel } from '../add-column-on-level';
import { absoluteTopImpressionRate, topImpressionRate } from '../shared/columns';
import agegenderTemplate from './agegender-template.pug';
import genderTemplate from './gender-template.pug';
import mediumTemplate from './medium-template.pug';

export function getAgeGenderColumnConfig({ i18n, bingadsGridColumn, pageContext }) {
  function column(options) {
    return bingadsGridColumn(_.defaults({}, options, { i18n }));
  }

  const { IsAvgPositionDeprecationPhase1Enabled } = pageContext.Permissions;

  return {
    getGridSpecificColumns: () => {
      const columns = [];

      columns.push(column({
        name: 'AgeGroup',
        title: 'ColumnName_AgeGroup',
        sortable: true,
        type: 'string',
        property: {
          get(row) {
            let ageGender = null;

            switch (row.AgeGroup) {
              case 0:
                ageGender = i18n.getString('Dimension_AgeGroup_0');
                break;
              case 1:
                ageGender = i18n.getString('Dimension_AgeGroup_1');
                break;
              case 2:
                ageGender = i18n.getString('Dimension_AgeGroup_2');
                break;
              case 3:
                ageGender = i18n.getString('Dimension_AgeGroup_3');
                break;
              case 4:
                ageGender = i18n.getString('Dimension_AgeGroup_4');
                break;
              case 5:
                ageGender = i18n.getString('Dimension_AgeGroup_5');
                break;
              case 6:
                ageGender = i18n.getString('Dimension_AgeGroup_6');
                break;
              case 7:
                ageGender = i18n.getString('Dimension_AgeGroup_7');
                break;
              case 99:
                ageGender = i18n.getString('Dimension_AgeGroup_8');
                break;
              default:
                break;
            }

            return {
              ageGender,
            };
          },
          key: 'AgeGroup',
        },
        template: agegenderTemplate,
        helpId: 'pop_BA_Reporting_Clarity_AgeGroup',
      }));

      columns.push(column({
        name: 'Gender',
        title: 'ColumnName_Gender',
        sortable: true,
        type: 'string',
        property: {
          get(row) {
            let gender = null;

            switch (row.Gender) {
              case 0:
                gender = i18n.getString('Dimension_Gender_0');
                break;
              case 1:
                gender = i18n.getString('Dimension_Gender_1');
                break;
              case 2:
                gender = i18n.getString('Dimension_Gender_2');
                break;
              default:
                break;
            }

            return {
              gender,
            };
          },
          key: 'Gender',
        },
        template: genderTemplate,
        helpId: 'Pop_BA_Reporting_Clarity_Gender',
      }));

      columns.push(column({
        name: 'Medium',
        title: 'ColumnName_Medium',
        sortable: true,
        type: 'number',
        property: {
          get(row) {
            let medium = null;

            switch (row.Medium) {
              case 0:
                medium = i18n.getString('Dimension_Medium_0');
                break;
              case 1:
                medium = i18n.getString('Dimension_Medium_1');
                break;
              case 2:
                medium = i18n.getString('Dimension_Medium_2');
                break;
              case 10:
                medium = i18n.getString('Dimension_Medium_3');
                break;
              case 11:
                medium = i18n.getString('Dimension_Medium_4');
                break;
              default:
                break;
            }

            return {
              medium,
            };
          },
          key: 'Medium',
        },
        template: mediumTemplate,
        helpId: 'pop_BA_NewCampaignCreate_Distribute',
      }));

      return columns;
    },
    getLevelOfDetailColumns: (level) => {
      const levelOfDetailColumns = [];

      addColumnOnLevel(column, levelOfDetailColumns, level);

      return levelOfDetailColumns;
    },
    getPerfColumns: () => _.compact([
      column({
        name: 'EstimatedImpressions',
        title: 'ColumnName_EstimatedImpressions',
        sortable: true,
        type: 'number',
        format: 'integer',
        helpId: 'pop_BA_Reporting_Clarity_EstImpr',
      }),
      column({
        name: 'EstimatedClicks',
        title: 'ColumnName_EstimatedClicks',
        sortable: true,
        type: 'number',
        format: 'integer',
        helpId: 'pop_BA_Reporting_Clarity_EstClicks',
      }),
      column({
        name: 'EstimatedCTR',
        title: 'ColumnName_EstimatedCTR',
        sortable: true,
        type: 'number',
        format: 'percentage-value',
        helpId: 'pop_BA_Reporting_Clarity_EstCTRPerc',
      }),
      column({
        name: 'EstimatedImpressionRate',
        title: 'ColumnName_EstimatedImpressionRate',
        sortable: true,
        type: 'number',
        format: 'percentage-value',
        helpId: 'pop_BA_Reporting_Clarity_EstImprRate',
      }),
      column({
        name: 'EstimatedClickRate',
        title: 'ColumnName_EstimatedClickPercent',
        sortable: true,
        type: 'number',
        format: 'percentage-value',
        helpId: 'pop_BA_Reporting_Clarity_EstClickPerc',
      }),
      IsAvgPositionDeprecationPhase1Enabled && column(topImpressionRate),
      IsAvgPositionDeprecationPhase1Enabled && column(absoluteTopImpressionRate),
    ]),
    getConversionColumns: () => [
      column({
        name: 'EstimatedConversions',
        title: 'ColumnName_EstimatedConversions',
        sortable: true,
        type: 'number',
        format: 'integer',
        helpId: 'pop_BA_Reporting_Clarity_EstConv',
      }),
      column({
        name: 'EstimatedConversionRate',
        title: 'ColumnName_EstimatedConversionRate',
        sortable: true,
        type: 'number',
        format: 'percentage-value',
        helpId: 'pop_BA_Reporting_Clarity_EstConvRate',
      }),
      column({
        name: 'EstimatedAllConversions',
        title: 'ColumnName_EstimatedAllConversions',
        sortable: true,
        type: 'number',
        format: 'integer',
        helpId: 'pop_BA_Reporting_Clarity_EstAllConv',
      }),
      column({
        name: 'EstimatedAllConversionRate',
        title: 'ColumnName_EstimatedAllConversionRate',
        sortable: true,
        type: 'number',
        format: 'percentage-value',
        helpId: 'pop_BA_Reporting_Clarity_EstAllConvRate',
      }),
    ],
  };
}
